export default __webpack_public_path__ + "static/media/fusion-power-bg.e850125d.jpeg";